import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import {
  getCourseById,
  deleteCourse,
  changePublishStatus,
  updateLessonOrder
} from "../../../../redux/educator/actions";
import { StateType } from "../../../../utils/types";
import {
  selectCourse,
  selectCoursesLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  loading: selectCoursesLoading(state),
  course: selectCourse(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getCourseById,
      deleteCourse,
      changePublishStatus,
      updateLessonOrder
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
